/* eslint-disabled */

export default class QuestionTypeExtend {


  constructor (object?: any) {
  }

}
